import { Card } from '@cmsgov/ds-medicare-gov'
import classNames from 'classnames'
import { MyLink } from 'components/MyLink'
import { useMedicareUrl } from 'hooks/useMedicareUrl'
import { useTranslation } from 'react-i18next'
import { useEvent } from 'events/useEvent'

const urls = {
  getStarted: {
    en: 'https://www.medicare.gov/basics/get-started-with-medicare',
    es: 'https://es.medicare.gov/basics/get-started-with-medicare'
  },
  planHistory: {
    en: 'https://www.medicare.gov/mbp/plansandcoverage.aspx',
    es: 'https://www.medicare.gov/mbp/plansandcoverage.aspx?Lang=es-mx'
  }
}

type NoPlansCardProps = {
  className?: string
}
export const NoPlansCard = ({ className }: NoPlansCardProps) => {
  const { t } = useTranslation('accountHome', {
    keyPrefix: 'currentPlans.noPlans'
  })
  const { fireEvent } = useEvent('accountHome')

  const getStartedUrl = useMedicareUrl(urls.getStarted.en, urls.getStarted.es)
  const planHistoryUrl = useMedicareUrl(
    urls.planHistory.en,
    urls.planHistory.es
  )

  return (
    <Card className={classNames('ds-u-padding--3', className)}>
      <h3 className="ds-text-heading--lg">{t('heading')}</h3>
      <div className="ds-u-margin-top--3">
        <MyLink
          className="ds-c-button ds-c-button--alternate ds-c-button--solid"
          href={getStartedUrl}
          onClick={({ linkText, linkUrl }) => fireEvent('accounthome_getstartedwithmedicare_click', {
            linkText,
            linkUrl
          })}
        >
          {t('getStartedLink')}
        </MyLink>

        <MyLink
          className="ds-c-button ds-u-md-margin-left--2"
          href={planHistoryUrl}
          onClick={({ linkText, linkUrl }) => fireEvent('accounthome_openplanhistory_click', {
            linkText,
            linkUrl
          })}
        >
          {t('planHistoryLink')}
        </MyLink>
      </div>
    </Card>
  )
}
